import { PlatformSiteAri } from '@atlassian/ari';

import { query, queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { shouldUseAGGActivityV3 } from '@confluence/home/entry-points/shouldUseAGGActivityV3.ts';

import { objectTypes, PAGE_SIZE } from './recentQueryConstants.ts';
import RecentContentMenuQuery, {
	type RecentContentMenuQuery$data,
	type RecentContentMenuQuery$variables,
} from './queries/__generated__/RecentContentMenuQuery.graphql.ts';

export function preloadRecentContentMenu(cloudId: any) {
	return (shouldUseAGGActivityV3() ? queryAgg : query)<
		RecentContentMenuQuery$data,
		RecentContentMenuQuery$variables
	>({
		query: RecentContentMenuQuery,
		variables: {
			cloudId: PlatformSiteAri.create({ siteId: cloudId }).toString(),
			after: '',
			first: PAGE_SIZE,
			eventTypes: [],
			objectTypes: objectTypes(),
		},
		fetchPolicy: 'network-only',
	});
}
